import {Component, OnInit} from '@angular/core';
import {Location} from "@angular/common";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ActivatedRoute, Router} from "@angular/router";
import {KeycloakService} from "../../services/keycloak.service";
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-create-serving-join-server',
  templateUrl: './add-serving-join-server.component.html',
})
export class AddServingJoinServerComponent implements OnInit {

  public nsName;
  public nsId;
  public nsVirtId;
  public protocolVersion;
  public showSearch = false;
  public searchText = '';
  public allJoinServer: any[] = [];
  public allJSWithVirtId: any[] = [];
  public jsVirtId;
  public subscriberId: string = "";
  public isEnable = false;
  public username: string = KeycloakService.username;

  private value:any = {};

  public selectedNS(value:any):void {
    this.searchText = value.split(",").splice(0)[0];
    this.isEnable = true;
    for(let jsValue of this.allJSWithVirtId) {
      if(jsValue.name == this.searchText){
        this.jsVirtId = jsValue.virtId;
      }
    }
  }

  public removed(value:any):void {
    this.isEnable = false;
  }

  constructor(private router: Router,
              private route: ActivatedRoute,
              private _location: Location,
              private http: HttpClient) {  }

  save(){
    var body: any = {
      "nsId": this.nsVirtId,
      "jsId": this.jsVirtId
      //"subscriberId": this.subscriberId
    };
    var url = ApiEndpoints.CREATE_ACTIVATION_AGREEMENT;
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers}
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this._location.back();
        }
      );
  }

  getAllJSWithSearch(virtId){
    var url = ApiEndpoints.GET_ALL_JOIN_SERVERS_WOA;
    var body = {
      "virtID" : virtId
    };
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers}
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            this.allJoinServer.push(index.name + ", " + index.joinEUIs.toString());
            this.allJSWithVirtId.push(index);
          }
        }
      );

  }

  backClicked() {
    this._location.back();
  }

  ngOnInit() {
    this.getAllJSWithSearch(this.route.snapshot.queryParams["virtId"]);
    this.nsName = this.route.snapshot.queryParams["name"];
    this.nsId = this.route.snapshot.queryParams["id"].toString();
    this.nsVirtId = this.route.snapshot.queryParams["virtId"];
    this.protocolVersion = this.route.snapshot.queryParams["protocolVersion"];

    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
  }

}
